import React, { useEffect, lazy, Suspense } from 'react';
import Hero from '../components/Hero';
import { Toaster } from '../components/ui/sonner';
import { Loader2 } from 'lucide-react';

// Lazy load components for better performance
const LocationAdvantage = lazy(() => import('../components/LocationAdvantage'));
const ProjectHighlights = lazy(() => import('../components/ProjectHighlights'));
const FloorPlans = lazy(() => import('../components/FloorPlans'));
const Amenities = lazy(() => import('../components/Amenities'));
const WhyDiva = lazy(() => import('../components/WhyDiva'));
const DeveloperTrust = lazy(() => import('../components/DeveloperTrust'));
const ConstructionPreview = lazy(() => import('../components/ConstructionPreview'));
const ContactForm = lazy(() => import('../components/ContactForm'));

// Loading fallback component
const LoadingFallback = () => (
  <div className="flex items-center justify-center py-20">
    <Loader2 className="w-8 h-8 animate-spin text-orange-500" />
  </div>
);

const Home = () => {
  useEffect(() => {
    // Handle hash navigation
    if (window.location.hash) {
      const element = document.getElementById(window.location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, []);

  return (
    <>
      <Hero />
      <Suspense fallback={<LoadingFallback />}>
        <LocationAdvantage />
      </Suspense>
      <Suspense fallback={<LoadingFallback />}>
        <ProjectHighlights />
      </Suspense>
      <Suspense fallback={<LoadingFallback />}>
        <FloorPlans />
      </Suspense>
      <Suspense fallback={<LoadingFallback />}>
        <Amenities />
      </Suspense>
      <Suspense fallback={<LoadingFallback />}>
        <WhyDiva />
      </Suspense>
      <Suspense fallback={<LoadingFallback />}>
        <DeveloperTrust />
      </Suspense>
      <Suspense fallback={<LoadingFallback />}>
        <ConstructionPreview />
      </Suspense>
      <Suspense fallback={<LoadingFallback />}>
        <ContactForm />
      </Suspense>
      <Toaster />
    </>
  );
};

export default Home;
